export const getSubdomain = () => {
  const hostname = window.location.hostname.toLowerCase();
  return hostname.split('.')[0];
};

export const redirectToSignUp = (subDomain) => {
  return subDomain === 'accounts';
};
